import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ICliente } from '../../../interfaces/cliente.interface';

import { urls } from '../../../../../environments/environment';

import * as md5 from 'blueimp-md5';

@Injectable()
export class CadastroService {

  constructor(
    private http: HttpClient) { }

  buscaCnpj(cnpj: string) {
    return this.http
      .get(urls.apiBaseActuar + '/Pessoas/ConsultarCnpj?cnpj=' + cnpj);
  }

  buscaEndereco(cep: string) {
    return this.http
      .get(urls.apiBaseActuar + '/Ceps/ObterEnderecoPeloCep?cep=' + cep);
  }

  adicionarConta(conta) {
    return this.http
      .post(urls.apiBase + '/Contas/Adicionar', conta);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth/cadastro/cadastro.service.ts